/**
 * @generated SignedSource<<86d666296c818028aa4c6a149f0268f5>>
 * @relayHash 9c6c7c1df5bfd2c51a560d5df2037bf3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6c23ec14d4753c8c1e76e6714c2c2be4b13266e630ef62c3a6402a19848453bf

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type KnowledgeDiscoveryKeyPhraseInputTextFormat = "ADF" | "PLAIN" | "%future added value";
export type KnowledgeDiscoveryKeyPhraseInputText = {
  format: KnowledgeDiscoveryKeyPhraseInputTextFormat;
  text: string;
};
export type preloadAutohighlightsQuery$variables = {
  entityAri: string;
  inputText?: KnowledgeDiscoveryKeyPhraseInputText | null;
  jiraAssigneeAccountId?: string | null;
  jiraReporterAccountId?: string | null;
  workspaceId: string;
};
export type preloadAutohighlightsQuery$data = {
  readonly autohighlightsQueryFragment: {
    readonly " $fragmentSpreads": FragmentRefs<"preloadAutohighlightsQuery_query">;
  };
};
export type preloadAutohighlightsQuery = {
  response: preloadAutohighlightsQuery$data;
  variables: preloadAutohighlightsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "entityAri"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "inputText"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "jiraAssigneeAccountId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "jiraReporterAccountId"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceId"
},
v5 = [
  {
    "kind": "Variable",
    "name": "entityAri",
    "variableName": "entityAri"
  },
  {
    "kind": "Variable",
    "name": "inputText",
    "variableName": "inputText"
  },
  {
    "kind": "Variable",
    "name": "jiraAssigneeAccountId",
    "variableName": "jiraAssigneeAccountId"
  },
  {
    "kind": "Variable",
    "name": "jiraReporterAccountId",
    "variableName": "jiraReporterAccountId"
  },
  {
    "kind": "Variable",
    "name": "workspaceId",
    "variableName": "workspaceId"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "preloadAutohighlightsQuery",
    "selections": [
      {
        "fragment": {
          "kind": "InlineFragment",
          "selections": [
            {
              "args": (v5/*: any*/),
              "kind": "FragmentSpread",
              "name": "preloadAutohighlightsQuery_query"
            }
          ],
          "type": "Query"
        },
        "kind": "AliasedInlineFragmentSpread",
        "name": "autohighlightsQueryFragment"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "preloadAutohighlightsQuery",
    "selections": [
      {
        "concreteType": "KnowledgeDiscoveryQueryApi",
        "kind": "LinkedField",
        "name": "knowledgeDiscovery",
        "plural": false,
        "selections": [
          {
            "args": (v5/*: any*/),
            "kind": "LinkedField",
            "name": "keyPhrases",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__typename"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "concreteType": "KnowledgeDiscoveryKeyPhrase",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "keyPhrase"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "category"
                      }
                    ]
                  }
                ],
                "type": "KnowledgeDiscoveryKeyPhraseConnection"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "message"
                  }
                ],
                "type": "QueryError"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "9c6c7c1df5bfd2c51a560d5df2037bf3",
    "id": "6c23ec14d4753c8c1e76e6714c2c2be4b13266e630ef62c3a6402a19848453bf",
    "metadata": {},
    "name": "preloadAutohighlightsQuery",
    "operationKind": "query",
    "text": "query preloadAutohighlightsQuery($entityAri:String!,$workspaceId:String!,$jiraReporterAccountId:String,$jiraAssigneeAccountId:String,$inputText:KnowledgeDiscoveryKeyPhraseInputText){...preloadAutohighlightsQuery_query_3JqkOF}fragment preloadAutohighlightsQuery_query_3JqkOF on Query{knowledgeDiscovery{keyPhrases(entityAri:$entityAri,workspaceId:$workspaceId,jiraReporterAccountId:$jiraReporterAccountId,jiraAssigneeAccountId:$jiraAssigneeAccountId,inputText:$inputText)@optIn(to:\"KnowledgeDiscovery Get Key Phrases\"){__typename,...on KnowledgeDiscoveryKeyPhraseConnection{nodes{keyPhrase,category}},...on QueryError{message}}}}"
  }
};
})();

(node as any).hash = "baeb32ab484b62c6c908fdf8f3a9b199";

export default node;
